import { useRef } from 'react';

// Stable React `key` per variant *object identity* over a component's
// lifetime. Editor sections replace variants via slice+assign, so the
// object reference changes whenever a row is edited — which produces a
// new key here too. That's fine: the row remounts on edit, and reordering
// or removing other rows never disturbs the keys of untouched rows.
export function useVariantKeys<T extends object>() {
  const ids = useRef(new WeakMap<T, string>());
  return (variant: T): string => {
    const existing = ids.current.get(variant);
    if (existing) return existing;
    const id = crypto.randomUUID();
    ids.current.set(variant, id);
    return id;
  };
}
